import React from 'react';

export const getFreebiesText = (title="", count=0) => {
    if(count<=0) return <></>;
    else if(count===1) return <span>{title.replace("${count}", "")}</span>;
    return <span>{title.replace("${count}", count.toString())}</span>;
};

export const getFreebiesTitle = (title= "" , count = 0) => {
    if (count === 1) return title.replace("${count}", "");
    if (count > 1) return title.replace("${count}", count.toString());
    else return ''
};

export const getGAFreebiesText = (text = '', count = '') => {
    const stringWithoutCount = text.replace(/\$\{count\}/g, '');
    const normalizedString = stringWithoutCount.replace(/\s+/g, ' ').trim();
    if (count) return `${normalizedString} - ${count}`;
    return normalizedString;
};